import React from 'react';

const ContentRenderer = ({ content }) => {
  return (
    <div 
      className="prose prose-lg max-w-none w-full  mx-auto"
      dangerouslySetInnerHTML={{ __html: content }} 
    />
  );
};

export default ContentRenderer;